export function isTouchDevice() {
  return ('ontouchstart' in window || navigator.maxTouchPoints) == true; // Check for touch event support
}